import { PriceSuggestionPriority } from '@retail/products/types';
import { dateFromString } from '@retail/utils';
import { ConditionBindingMinimal, PriceSourceConditionDTO } from '../../dtos/ConditionsNewDTO';

export interface PriceSourceConditionProps {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  priorities: PriceSuggestionPriority[];
  validFrom: Date;
  validTo?: Date;
}

export class PriceSourceCondition {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  priorities: PriceSuggestionPriority[];
  validFrom: Date;
  validTo?: Date;

  constructor({
    conditionId,
    isInherited,
    inheritedBinding,
    isDeletionCondition,
    priorities,
    validFrom,
    validTo,
  }: PriceSourceConditionProps) {
    this.conditionId = conditionId;
    this.isInherited = isInherited;
    this.inheritedBinding = inheritedBinding;
    this.isDeletionCondition = isDeletionCondition;
    this.priorities = priorities;
    this.validFrom = validFrom;
    this.validTo = validTo;
  }

  static fromDto = (dto: PriceSourceConditionDTO): PriceSourceCondition =>
    new PriceSourceCondition({
      conditionId: dto.conditionId,
      isInherited: dto.isInherited,
      inheritedBinding: dto.inheritedBinding,
      isDeletionCondition: dto.isDeletionCondition,
      priorities: dto.priorities ?? [],
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
    });
}
